import { render } from "./AdminTop.vue?vue&type=template&id=f80d5154"
import script from "./AdminTop.vue?vue&type=script&lang=js"
export * from "./AdminTop.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__